module.exports = __webpack_public_path__ + "img/tire-care.c2ec3324.svg";